var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 48,
    viewBox: "0 0 35 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1426 0C26.6102 0 34.2861 3.88797 34.2861 17.1426C34.2861 30.3973 27.4282 39.4286 17.1426 48C8.57123 39.4286 0 30.3973 0 17.1426C7.46395e-05 3.88819 7.67515 0.000130063 17.1426 0ZM17.1426 10.7148C13.3555 10.7148 10.2852 13.7852 10.2852 17.5723C10.2854 21.3591 13.3557 24.4287 17.1426 24.4287C20.9294 24.4286 23.9997 21.3591 24 17.5723C24 13.7852 20.9296 10.7149 17.1426 10.7148Z",
    fill: "#D6AAD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPin);
export default __webpack_public_path__ + "static/media/ic_pin.7e9dce8d4766518640dd005a474b4e85.svg";
export { ForwardRef as ReactComponent };